import { render, staticRenderFns } from "./athenaProductItemBtn.vue?vue&type=template&id=3d93fd35&scoped=true&"
import script from "./athenaProductItemBtn.vue?vue&type=script&lang=js&"
export * from "./athenaProductItemBtn.vue?vue&type=script&lang=js&"
import style0 from "./athenaProductItemBtn.vue?vue&type=style&index=0&id=3d93fd35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d93fd35",
  null
  
)

export default component.exports